'use client';

import useClientStore from '@/store/useClientStore';
import BuilderPageWrapper from '@/components/builder2/BuilderPageWrapper';
import { useTranslation } from '@/i18n/hooks/useTranslation';

function TraditionalAbout() {
  const { client } = useClientStore();
  // Textos por i18n: en español idénticos a los de siempre (sin clave en
  // inglés, caen al español); Brasil en portugués.
  const { t } = useTranslation();
  return (
    <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 bg-white dark:bg-dark-bg transition-colors duration-300'>
      <div className='text-center mb-16'>
        <h1 className='text-4xl font-extrabold text-gray-900 dark:text-white sm:text-5xl'>
          {t('site.about.title')}
        </h1>
        <p className='mt-4 text-xl text-gray-500 dark:text-gray-400'>
          {t('site.about.knowMore')}{client?.name || t('site.about.fallbackName')}
        </p>
      </div>
      <div className='text-center py-16'>
        <p className='text-gray-400'>{t('site.about.comingSoon')}</p>
      </div>
    </div>
  );
}

export default function AboutPage() {
  return <BuilderPageWrapper slug="about" fallback={<TraditionalAbout />} />;
}
